import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const PulseXIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/pulsexC.png" style={style} />
}
